import { SmartLockInternalState } from "../enums/SmartLockInternalStateEnum";

export class SmartLock {
    smartLockSerialNumber: string;
    lastContactDate: Date;
    internalState: SmartLockInternalState;
    lastNonce: string;
    workModeOptions: string;
    manualAuthorized: boolean = false;

    public parse(obj: any) {
        if (obj.SmartLockSerialNumber) this.smartLockSerialNumber = obj.SmartLockSerialNumber;
        if (obj.LastContactDate) this.lastContactDate = obj.LastContactDate;
        if (obj.InternalState) this.internalState = obj.InternalState;
        if (obj.LastNonce) this.lastNonce = obj.LastNonce;
        if (obj.WorkModeOptions) this.workModeOptions = JSON.parse(obj.WorkModeOptions);
        if (obj.ManualAuthorized) this.manualAuthorized = obj.ManualAuthorized;
    }
}
